<projects-task-new-item-wrapper
  [activePanel]="ProjectTaskDialogPanels.DateTimePicker"
  (cancel)="onCancel()"
  (save)="onSave()"
>
  <div class="content-container">
    <task-calendar
      [form]="form()"
      [control]="$any(dateControl)"
      [minDate]="minDate()"
      (dateChange)="onDateChange($any($event))"
    ></task-calendar>
    @if (!disableTimeSelector()) {
      <div class="time-selector-container">
        <div class="wrap-container">
          <span>{{ dateControl.value | moment: 'MMM D, yyyy' }}</span>
          <span>at</span>
        </div>
        <div class="wrap-container">
          <oph-time-selector
            [hoursControl]="$any(hoursControl)"
            [minutesControl]="$any(minutesControl)"
            [ampmControl]="$any(ampmControl)"
          ></oph-time-selector>
          <oph-icon name="clock-brown-2" [size]="24"></oph-icon>
        </div>
      </div>
    } @else {
      <div class="time-selector-container">
        <div class="wrap-container">
          <span>{{ dateControl.value | moment: 'MMM D, yyyy' }} at {{ dateControl.value | moment: 'h:mm A' }}</span>
        </div>
      </div>
    }
  </div>
</projects-task-new-item-wrapper>
